import axios from "axios";
import { getCookie } from "./csrf";

const axiosInstance = axios.create({
    headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
    },
    withCredentials: true
});

axiosInstance.interceptors.request.use(
    (config) => {
        const csrfToken = getCookie("csrftoken") || localStorage.getItem("csrfToken");
        if (csrfToken) {
            config.headers["X-CSRFToken"] = csrfToken;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        console.error('Request error:', error);
        return Promise.reject(error);
    }
);
console.log(process.env.NODE_ENV)

export default axiosInstance;



